import { TemplateSource } from '~/src/types/template';

/**
 * Checks if a template was transferred and created within the last 7 days.
 * Used to determine if a "New" badge should be displayed for transferred templates.
 * @param template - Template object with a template source of CLIO_TRANSFERRED
 * @returns True if the template was transferred and is newer than 7 days
 */
export function isTransferredAndNewerThan7Days(template: {
  templateSource?: string | null;
  createdAt?: string | null;
}): boolean {
  return Boolean(
    template.templateSource === TemplateSource.CLIO_TRANSFERRED &&
      template.createdAt &&
      new Date(template.createdAt) >
        new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
  );
}
